module.exports = __webpack_public_path__ + "static/media/yckss.58101994.png";